<template>
  <SAIDrawer
    :open="open"
    :org-contact-email="orgContactEmail"
    :org-contact-phone="orgContactPhone"
    @input="$emit('update:open')"
    :width-offset="widthOffset"
  >
    <QList v-if="!loggedOut">
      <QItem
        v-for="(route, index) in routes"
        :key="index"
        :to="route.to"
        dense
        class="q-pa-none text-white o-60"
        active-class="o-100"
      >
        <QItemSection class="text-title">{{ route.label }}</QItemSection>
      </QItem>
    </QList>

    <div class="q-mt-lg" v-if="!loggedOut">
      <SAIBtn
        v-if="!blockCreateQuote"
        label="New Quote"
        outline
        :no-caps="true"
        padding="12px 80px"
        @click="$emit('create:quote')"
      />
    </div>
  </SAIDrawer>
</template>

<script>
import { QList, QItem, QItemSection } from 'quasar';
import { SAIDrawer, SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'MenuDrawer',
  props: {
    open: Boolean,
    orgContactEmail: String,
    orgContactPhone: String,
    loggedOut: Boolean,
    blockCreateQuote: Boolean,
    routes: {
      type: Array,
      default: () => []
    },
    widthOffset: Number
  },
  components: {
    SAIDrawer,
    QList,
    QItem,
    QItemSection,
    SAIBtn
  }
};
</script>
